import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useEffectOnce } from 'react-use';
import classnames from 'classnames';
import updateVisibleHeightOfPromoBanner from 'commons/updateVisibleHeightOfPromoBanner';
import setPromoBannerVisibleHeightCssVar from 'commons/setPromoBannerVisibleHeightCssVar';
import removeNull from 'commons/removeNull';
import useUserData from 'data-hooks/useUserData';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import getEnvironmentName from 'commons/getEnvironmentName';
import useIsBrowser from 'hooks/useIsBrowser';
import getDisplayDate from './helpers/getDisplayDate';
import PromotionContent from './components/PromotionContent';
const PromotionBanner = t0 => {
  const $ = _c(30);
  const {
    config: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const config = t2;
  const defaultValuesRef = useRef();
  const [isPromoBannerVisible, setIsPromoBannerVisible] = useState(true);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [displayValue, setDisplayValue] = useState(t3);
  const promoBannerRef = useRef();
  const {
    isTradeUser
  } = useUserData();
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (endDate, dateFormat, interval) => {
      const timeDiff = endDate.getTime() - Date.now();
      if (timeDiff > 0) {
        const displayValueUpdated = getDisplayDate(timeDiff, dateFormat);
        setDisplayValue(displayValueUpdated);
      } else {
        clearInterval(interval);
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const setTimeDiff = t4;
  let t5;
  if ($[4] !== config) {
    t5 = () => {
      defaultValuesRef.current = {
        textColor: "#dbeded",
        mainContent: "",
        subContent: "",
        endDate: new Date().toUTCString(),
        countDownFormat: "D H M S",
        secondaryBannerText: null
      };
      const endDate_0 = new Date(config ? config.endDate : defaultValuesRef.current.endDate);
      const dateFormat_0 = config ? config.countDownFormat : defaultValuesRef.current.countDownFormat;
      updateVisibleHeightOfPromoBanner();
      const updateHeightInterval = setInterval(_temp, 500);
      const interval_0 = setInterval(() => {
        setTimeDiff(endDate_0, dateFormat_0, interval_0);
      }, 1000);
      return () => {
        clearInterval(interval_0);
        clearInterval(updateHeightInterval);
      };
    };
    $[4] = config;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useEffectOnce(t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setPromoBannerVisibleHeightCssVar(0);
      setIsPromoBannerVisible(false);
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const hidePromoBar = t6;
  const {
    textColor,
    mainContent,
    subContent,
    countdownToggle,
    backgroundImage,
    backgroundHeight,
    topBannerText
  } = config || defaultValuesRef.current;
  let t7;
  if ($[7] !== backgroundHeight) {
    t7 = backgroundHeight ? `${backgroundHeight.endsWith("px") ? backgroundHeight : `${backgroundHeight}px`}` : null;
    $[7] = backgroundHeight;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const promoStyleObj = {
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : null,
    height: t7
  };
  const isBrowser = useIsBrowser();
  const shouldShowCountdown = !!countdownToggle && (!isNewConsumerApp || isBrowser && displayValue.length > 0);
  const shouldHidePromotionTextUntilCountdownReady = isNewConsumerApp && !!countdownToggle && !shouldShowCountdown;
  let t8;
  bb0: {
    if (!isNewConsumerApp) {
      t8 = false;
      break bb0;
    }
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = ["dev", "stg"];
      $[9] = t9;
    } else {
      t9 = $[9];
    }
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = getEnvironmentName();
      $[10] = t10;
    } else {
      t10 = $[10];
    }
    const isParallelEnvironment = t9.includes(t10);
    let t11;
    if ($[11] !== isBrowser) {
      t11 = isBrowser ? window.location.hostname.includes("dev.nest.") || window.location.hostname.includes("stg.nest.") : false;
      $[11] = isBrowser;
      $[12] = t11;
    } else {
      t11 = $[12];
    }
    const isParallelEnvironmentHost = t11;
    t8 = isParallelEnvironment || isParallelEnvironmentHost;
  }
  const showGrayBackgroundColor = t8;
  if (!mainContent || !isPromoBannerVisible || isBrowser && isTradeUser) {
    return null;
  }
  const t9 = "PromotionBanner";
  const t10 = !showGrayBackgroundColor;
  let t11;
  if ($[13] !== showGrayBackgroundColor || $[14] !== t10) {
    t11 = classnames("items-center flex min-h-[55px] relative w-full z-[1003] max-[767px]:min-h-[70px] max-[767px]:pt-[5px] max-[767px]:px-0 max-[767px]:pb-2.5", {
      "bg-gray": showGrayBackgroundColor,
      "bg-brand-dark": t10
    });
    $[13] = showGrayBackgroundColor;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = removeNull(promoStyleObj);
  let t13;
  if ($[16] !== t12) {
    t13 = {
      ...t12
    };
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== displayValue || $[19] !== mainContent || $[20] !== shouldHidePromotionTextUntilCountdownReady || $[21] !== shouldShowCountdown || $[22] !== subContent || $[23] !== textColor || $[24] !== topBannerText) {
    t14 = <PromotionContent shouldShowCountdown={shouldShowCountdown} shouldHidePromotionTextUntilCountdownReady={shouldHidePromotionTextUntilCountdownReady} displayValue={displayValue} hidePromoBar={hidePromoBar} isCategoryNecessary={false} mainContent={mainContent} subContent={subContent} textColor={textColor} topBannerText={topBannerText} />;
    $[18] = displayValue;
    $[19] = mainContent;
    $[20] = shouldHidePromotionTextUntilCountdownReady;
    $[21] = shouldShowCountdown;
    $[22] = subContent;
    $[23] = textColor;
    $[24] = topBannerText;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t13 || $[28] !== t14) {
    t15 = <div data-xc={t9} className={t11} style={t13} ref={promoBannerRef}>{t14}</div>;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
PromotionBanner.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    countDownFormat: PropTypes.string,
    endDate: PropTypes.string,
    mainContent: PropTypes.string,
    topBannerText: PropTypes.string,
    subContent: PropTypes.string,
    textColor: PropTypes.string
  })
};
export default PromotionBanner;
function _temp() {
  updateVisibleHeightOfPromoBanner();
}